import { RouteType } from "types/RouteType";
import MappingQueueStore from "./MappingQueueStore";

const mappingQueueRoute: RouteType[] = [
  {
    name: "MappingQueue",
    path: "/meeting-mapping-queue",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Mapping Queue",
        enableRefreshButton: true,
        component: () => import("./MappingQueue.Header"),
      },
      body: {
        component: () => import("./MappingQueue.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    searchAliases: ["unmapped meetings", "assign client"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.mappingQueueStore as MappingQueueStore;
      store?.load();
      // Live channel: newly ingested meetings land in this queue without a
      // manual refresh (mirrors Meetings / Review Queue).
      store?.subscribe();
    },
    onExit: ({ rootStore }) => {
      // Tear down the live subscription so the socket handler doesn't leak.
      (rootStore.mappingQueueStore as MappingQueueStore)?.dispose();
    },
  },
];

export default mappingQueueRoute;
